angular
    .module('app', [
        'ui.router',
        'ngMessages',
        'angular-click-outside',
        'ui.select',
        'ngSanitize',
        'ngResource',
        'angularUtils.directives.dirPagination',
        'chart.js',
        'angular-loading-bar',
        'zcooly.i18n'
    ]);